import {
  Component,
  Input,
  HostBinding,
  DoCheck,
  DOCUMENT,
  inject
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { RadioQuestionV3 } from '../../../classes/question-radio';
import { QuestionBaseV3ComponentDirective } from '../question-base.component';

@Component({
  selector: 'bepatient-input-radio-v3',
  templateUrl: './input-radio.component.html',
  styleUrls: ['./input-radio.component.scss'],
  standalone: false
})
export class InputRadioComponentV3
  extends QuestionBaseV3ComponentDirective
  implements DoCheck
{
  private sanitizer = inject(DomSanitizer);
  document = inject(DOCUMENT);

  @Input() question: RadioQuestionV3;
  @Input() color: string;
  dirty: boolean;

  @HostBinding('attr.style')
  get valueAsStyle(): any {
    return this.sanitizer.bypassSecurityTrustStyle(
      `--data-color-checked: ${this.color}`
    );
  }

  get value() {
    return this.formGroup.get(this.question.key).value;
  }

  onChange(): void {
    this.formGroup.get(this.question.key).markAsTouched();
    this.dirty = this.formGroup.get(this.question.key).dirty;
  }

  ngDoCheck(): void {
    this.dirty = this.formGroup.get(this.question.key).dirty;
  }
}
